export default __webpack_public_path__ + "static/media/1-2.520e51c8.webp";